import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import "../styles/home.css";
import api from "../api/axiosPublic";

export default function Home() {
  const [cursos, setCursos] = useState([]);

  useEffect(() => {
    api.get("/cursos").then(res => setCursos(res.data));
  }, []);

  return (
    <>
      {/* ================= HERO ================= */}
      <section className="hero">
        <video
          className="hero-video"
          src="/video-hero.mp4"
          autoPlay
          muted
          loop
          playsInline
          ref={(video) => {
            if (video) video.playbackRate = 0.6;
          }}
        />

        <div className="hero-overlay">
          <h1>Centro de Estudios Millenials</h1>

          <p className="hero-subtitle">
            Cursos profesionales con clases en vivo y docentes especializados.
            <br />
            <span className="hero-highlight">
              El aprendizaje no tiene límites ni fronteras
            </span>
          </p>

          {/* BANDERAS */}
          <div className="hero-flags">
          <div className="flags-viewport">
            <div className="flags-track">
              <span>🇨🇱</span>
              <span>🇦🇷</span>
              <span>🇲🇽</span>
              <span>🇪🇸</span>
              <span>🇺🇸</span>
              <span>🇵🇪</span>
              <span>🇧🇷</span>
              <span>🇨🇴</span>
              <span>🇪🇨</span>

              {/* duplicadas */}
              <span>🇨🇱</span>
              <span>🇦🇷</span>
              <span>🇲🇽</span>
              <span>🇪🇸</span>
              <span>🇺🇸</span>
              <span>🇵🇪</span>
              <span>🇧🇷</span>
              <span>🇨🇴</span>
              <span>🇪🇨</span>

              <span>🇨🇱</span>
              <span>🇦🇷</span>
              <span>🇲🇽</span>
              <span>🇪🇸</span>
              <span>🇺🇸</span>
              <span>🇵🇪</span>
              <span>🇧🇷</span>
              <span>🇨🇴</span>
              <span>🇪🇨</span>
            </div>
          </div>
        </div>

          <Link to="/cursos" className="hero-btn">
            Ver Master Class disponibles
          </Link>
        </div>
      </section>

      {/* ================= BENEFICIOS ================= */}
      <section className="beneficios">
        <h2>¿POR QUÉ ESTUDIAR CON NOSOTROS?</h2>

        <div className="beneficios-grid">
          <div>
            <h3>Clases en vivo</h3>
            <p>Interactúa en tiempo real con docentes expertos.</p>
          </div>

          <div>
            <h3>Contenido práctico</h3>
            <p>Enfocado en el mundo laboral real.</p>
          </div>

          <div>
            <h3>Master Class</h3>
            <p>Aprende en una sola sesión intensiva.</p>
          </div>
        </div>
      </section>

      {/* ================= CURSOS DESTACADOS ================= */}
      <section className="cursos-destacados">
      <h2>Cursos destacados</h2>

      <div className="carrusel">
        <div className="carrusel-track">
        {cursos.length > 0 &&
          [...cursos, ...cursos, ...cursos, ...cursos].map((c, i) =>
            c.imagen ? (
              <img
                key={`curso-${c.id}-${i}`}
                src={`https://centromillennials.com/uploads/${c.imagen}`}
                alt={c.nombre}
                className="carrusel-img"
                loading="lazy"
              />
            ) : null
          )
        }
        </div>
      </div>
    </section>

      {/* ================= NOSOTROS ================= */}
      <section className="nosotros">
        <h2>ACERCA DEL CENTRO DE ESTUDIOS MILLENNIALS (CEM)</h2>
        <p>
        FORMACIÓN ONLINE DE CALIDAD CON DOCENTES ESPECIALIZADOS Y ENFOQUE PRÁCTICO.
        </p>
        <Link to="/nosotros" className="hero-btn">Saber más</Link>
      </section>
    </>
  );
}
